import React from 'react';
import { Button } from 'swag-client-common/components/ui/button';
import classes from '../../checkout-block.scss';
import { TYPE } from '../../button-type';
export const ProceedButtonComponent = ({
  onCheckoutClick,
  text
}) => /*#__PURE__*/React.createElement(Button, {
  dataButton: "Buy",
  type: TYPE,
  size: "small",
  onClick: onCheckoutClick,
  className: classes.button
}, text);